module.exports = __webpack_public_path__ + "static/media/factory.5bdb7be1.svg";